import {Settings} from './Settings';
//import {Math as FuelMath}  from './Math'
//import {MathFormula} from './Math'
import { RoundValueASTM } from './FuelMath';
export class EnergyCalculationService
{

    static response={
        GSETextBox:"",
        NSETextBox:""
    };
    /* static NetHeatOfCombustion(val)
    {
        return RoundValueASTM(val,0.0001);
        //return MathFormula.RoundValueASTM(val,0.0001);

    } */
    static calculate(config)
    {

        /*
        
        calcmethod,
        fueltype,
        DensityNumTextBox,
        VolumePctCheckBox,
        WaterNumTextBox,
        AshNumTextBox,
        SulphurNumTextBox,
        GHC,
        hydrogen
        
        */
       ;
        if(config.calcmethod=="ASTM D240")
        {
            let NCV = (config.GHC) - (0.2122 * config.hydrogen)
	        this.response.NSETextBox = ((NCV).toFixed(2))/* RoundValueASTM(this.NetHeatOfCombustion(NCV),Settings.Energy); */
	        //this.response.NSETextBox = (MathFormula.RoundValueASTM(this.NetHeatOfCombustion(NCV),Settings.Energy).toFixed(2));
        }
        else
        {
            this.CalculateSpecificEnergy(config);
        }
        return this.response;
    }
    static CalculateSpecificEnergy(config)
    {
        ;
        let water=0;
        let density  = config.DensityNumTextBox ?parseFloat(config.DensityNumTextBox):0;
        let ash = config.AshNumTextBox ?parseFloat(config.AshNumTextBox):0;
        let sulphur = config.SulphurNumTextBox ?parseFloat(config.SulphurNumTextBox):0;
        let densityPow2=Math.pow(density,2);
        let tpm6=Math.pow(10,-6);
        let tpm3=Math.pow(10,-3);
        if(config.VolumePctCheckBox==true)
        {
            water = parseFloat(config.WaterNumTextBox) / parseFloat(config.DensityNumTextBox / 1000)
        }
        else
        {
            water = parseFloat(config.WaterNumTextBox);
        }

        switch(config.calcmethod) {
            case "ISO 8217:2017":
                if (config.fueltype=="Residual") 
                {
                        this.response.GSETextBox = (RoundValueASTM((52.19 - (8.802 * densityPow2 * tpm6)) * (1.0 - 0.01 * (water + ash + sulphur)) + 0.0942 * sulphur).toFixed(2));
                        this.response.NSETextBox = (RoundValueASTM((46.704 - (8.802 * densityPow2 * tpm6) + (3.167 * density * tpm3)) * (1.0 - 0.01 * (water + ash + sulphur)) + 0.0942 * sulphur - 0.02449 * water).toFixed(2));
                }
                else
                {
                    this.response.GSETextBox  = (RoundValueASTM((51.916 - (8.792 * densityPow2 * tpm6)) * (1.0 - 0.01 * (water + ash + sulphur)) + 0.0942 * sulphur).toFixed(2))
                    this.response.NSETextBox = (RoundValueASTM((46.423 - (8.792 * densityPow2 * tpm6) + (3.17 * density * tpm3)) * (1.0 - 0.01 * (water + ash + sulphur)) + 0.0942 * sulphur - 0.02449 * water).toFixed(2));       
                }

              // code block
              break;
              case "ISO 8217:2012":
                if (config.fueltype=="Residual") 
                {
                        this.response.GSETextBox = (RoundValueASTM((52.19 - (8.802 * densityPow2 * tpm6)) * (1.0 - 0.01 * (water + ash + sulphur)) + 0.0942 * sulphur).toFixed(2));
                        this.response.NSETextBox = (RoundValueASTM((46.704 - (8.802 * densityPow2 * tpm6) + (3.167 * density * tpm3)) * (1.0 - 0.01 * (water + ash + sulphur)) + 0.0942 * sulphur - 0.02449 * water).toFixed(2));
                }
                else
                {
                    this.response.GSETextBox  = (RoundValueASTM((51.916 - (8.792 * densityPow2 * tpm6)) * (1.0 - 0.01 * (water + ash + sulphur)) + 0.0942 * sulphur).toFixed(2))
                    this.response.NSETextBox = (RoundValueASTM((46.423 - (8.792 * densityPow2 * tpm6) + (3.17 * density * tpm3)) * (1.0 - 0.01 * (water + ash + sulphur)) + 0.0942 * sulphur - 0.02449 * water).toFixed(2));       
                }

              // code block
              break;
            
            case "ISO 8217:2010":
                if (config.fueltype=="Residual") 
                {
                        this.response.GSETextBox = (RoundValueASTM((52.19 - (8.802 * densityPow2 * tpm6)) * (1.0 - 0.01 * (water + ash + sulphur)) + 0.0942 * sulphur).toFixed(2));
                        this.response.NSETextBox = (RoundValueASTM((46.704 - (8.802 * densityPow2 * tpm6) + (3.167 * density * tpm3)) * (1.0 - 0.01 * (water + ash + sulphur)) + 0.0942 * sulphur - 0.02449 * water).toFixed(2));
                }
                else
                {
                    this.response.GSETextBox  = (RoundValueASTM((51.916 - (8.792 * densityPow2 * tpm6)) * (1.0 - 0.01 * (water + ash + sulphur)) + 0.0942 * sulphur).toFixed(2))
                    this.response.NSETextBox = (RoundValueASTM((46.423 - (8.792 * densityPow2 * tpm6) + (3.17 * density * tpm3)) * (1.0 - 0.01 * (water + ash + sulphur)) + 0.0942 * sulphur - 0.02449 * water).toFixed(2));       
                }

              // code block
              break;
            case "ISO 8217:2005":
                if (config.fueltype=="Residual") 
                {
                    this.response.GSETextBox =(RoundValueASTM((52.19 - (8.802 * densityPow2 * tpm6)) *  (1.0 - 0.01 * (water + ash + sulphur)) + 0.0942 * sulphur).toFixed(2))
                    this.response.NSETextBox =(RoundValueASTM((46.704 - (8.802 * densityPow2 * tpm6) + (3.167 * density * tpm3))  * (1.0 - 0.01 * (water + ash + sulphur)) + 0.0942 * sulphur - 0.024 * water).toFixed(2))
                }
                else
                {
                    this.response.GSETextBox = ""
                    this.response.NSETextBox = (RoundValueASTM((46.423 - (8.792 * densityPow2 * tpm6) + (3.15 * density * tpm3))  * (1.0 - 0.01 * (water + ash + sulphur)) + 0.0942 * sulphur - 0.024 * water).toFixed(2))
                }
              // code block
              break;
            case "ISO 8217:1996":
                this.response.GSETextBox = (RoundValueASTM((52.19 - (8.802 * densityPow2 * tpm6)) *   (1.0 - 0.01 * (water + ash + sulphur)) + 0.0942 * sulphur).toFixed(2))
                this.response.NSETextBox = (RoundValueASTM((46.704 - (8.802 * densityPow2 * tpm6) + (3.167 * density * tpm3))  * (1.0 - 0.01 * (water + ash + sulphur)) + 0.0942 * sulphur - 0.02449 * water).toFixed(2))
            // code block
            break;
            case "ASTM D4868":
                this.response.GSETextBox = (RoundValueASTM((51.916 - (8.792 * densityPow2 * tpm6)) *   (1.0 - 0.01 * (water + ash + sulphur)) + 0.0942 * sulphur).toFixed(2))
                this.response.NSETextBox = (RoundValueASTM((46.423 - (8.792 * densityPow2 * tpm6) + (3.17 * density * tpm3))   * (1.0 - 0.01 * (water + ash + sulphur)) + 0.0942 * sulphur - 0.02449 * water).toFixed(2))
            // code block
            break;  
            default:
              // code block
          }
        
    }
}